import classNames from 'classnames';
import React from 'react';
import {
	IChatCommandWidgetAccordionData,
	IChatCommandWidgetMessage,
} from '@enuan/chat__utils';
import { Accordion } from './components/Accordion';
import { getMessageFormPrefix } from '../../../utils';
import { useOnAction } from '../../widgets/useOnAction';
import { useMessageContext } from '../../message/message.context';
import { useBlockMessageClassNames } from 'src/hooks/core/messages.hooks';
import { Message } from '../../UI/Message/Message';
import { styled } from '@mui/material/styles';
import type { IOptionalMessageProps } from '../../UI/Message/Message';

type IAccordionMessageContent =
	IChatCommandWidgetMessage<IChatCommandWidgetAccordionData>;

export const AccordionMessage = styled(
	React.forwardRef<HTMLElement, { className?: string } & IOptionalMessageProps>(
		function AccordionMessage({ className, ...messageProps }, ref) {
			const { message } = useMessageContext<IAccordionMessageContent>();
			const messageClassName = useBlockMessageClassNames();
			const {
				client_id,
				_data: {
					parameters: { data },
				},
				metadata: { id },
			} = message;
			const onAction = useOnAction(id);

			return (
				<Message
					{...messageProps}
					ref={ref}
					message={message}
					className={classNames(
						className,
						messageClassName,
						'message--accordion',
					)}
					customHeader={null}
					customFooter={null}
					customAvatar={null}
					wrapBalloon={false}
					customExtra={
						<Accordion
							command_id={id}
							prefix={getMessageFormPrefix(client_id)}
							cards={data.items}
							onAction={onAction}
						/>
					}
				/>
			);
		},
	),
	{ label: 'AccordionMessage', target: 'AccordionMessage-root' },
)({
	'&.message--accordion': {
		marginTop: '0.175em',
		'& .message__extra': {
			overflow: 'hidden',
		},
	},
});
